import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../utils/translations';
import SergicLogo from './SergicLogo';
import LanguageSelector from './LanguageSelector';

interface DesktopHeaderProps {
  language: 'fr' | 'en';
  onLanguageChange: (language: 'fr' | 'en') => void;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({ language, onLanguageChange }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const t = useTranslation(language);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <SergicLogo className="h-8" />
          <h1 className="text-xl font-semibold text-gray-900">{t('copropriety.assistant')}</h1>
        </div>
        
        <div className="flex items-center space-x-4">
          <LanguageSelector language={language} onLanguageChange={onLanguageChange} />
          
          <div className="flex items-center space-x-3">
            <span className="text-sm text-gray-600">
              {user?.firstName ? `${user.firstName} ${user.lastName || ''}` : user?.email}
            </span>
            <button
              onClick={() => navigate('/profile')}
              className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded-md hover:bg-gray-100"
            >
              Profil
            </button>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded-md hover:bg-gray-100"
            >
              {t('logout')}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DesktopHeader;
